export const baseUrl = process.env.VUE_APP_BASE_API || "/"
